import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Paper, IconButton, InputBase } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useDebounce } from './Debounce.hooks';

const StyledSearchBox = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0 20px;
  .search {
    flex: 1;
    display: flex;
    padding: 5px;
    max-width: 512px;
    .MuiInputBase-root {
      width: 100%;
    }
  }
`;

export interface SearchBoxProps {
  value?: string | null;
  children?: React.ReactNode;
  onSearch?: (search: string) => void;
}

const SearchBox: React.FC<SearchBoxProps> = ({ value, children, onSearch }) => {
  const [search, setSearch] = useState<string>(value || '');
  const debouncedSearch = useDebounce(search, 300);

  // update search to latest value
  useEffect(() => setSearch(value || ''), [value]);

  useEffect(() => {
    // only update when debounced value changed
    if (value !== debouncedSearch) {
      onSearch?.(debouncedSearch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  return (
    <StyledSearchBox className='search-box'>
      <Paper className='search'>
        <IconButton aria-label='search' size='small'>
          <SearchIcon />
        </IconButton>
        <InputBase
          id='search-textfield'
          placeholder='Search'
          type='search'
          value={search}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setSearch(event.target.value);
          }}
          onKeyPress={(event: any) => {
            if (event.key === 'Enter') {
              onSearch?.(search);
            }
          }}
        />
      </Paper>
      {children}
    </StyledSearchBox>
  );
};

export default SearchBox;
